(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"]) return;
  try {
    
      var $flexslider3 = $('.bsd');
$flexslider3.flexslider({
  animation: "slide",
  manualControls: ".flex-control-nav li",
  useCSS: false /* Chrome fix*/,
  slideshowSpeed: 4000
});
  
        var $flexslider4 = $('.msd');
$flexslider4.flexslider({
  animation: "slide",
  manualControls: ".flex-control-nav li",
  useCSS: false /* Chrome fix*/,
  slideshowSpeed: 4000
});

  } catch(e) { console.error(e); }
})();
})();
